<app-service-nursing-care-diagnosis-group-dialog></app-service-nursing-care-diagnosis-group-dialog>
<app-card [title]="title" titleSize="large" class="pb-3" height="initial">
    <ng-template #content>
        <div class="grid-6col input-grid-gaps">
            <div class="grid-3col input-grid-gaps fr-3">
                <app-text-input [form]="form" id="code" label="service.nursingDiagnoses.fields.code"></app-text-input>
                <app-text-input [form]="form" id="title" label="service.nursingDiagnoses.fields.title"></app-text-input>
                <div>
                    <app-select-input
                        [form]="form"
                        id="groupId"
                        label="service.nursingDiagnoses.fields.groupName"
                        [staticOptions]="store.diagnosisGroups$ | async"
                        [autoDisplayFirst]="false"
                        valueKey="id">
                        <ng-template #item let-data>
                            <div class="flex justify-content-between align-items-center">
                                <div class="flex align-items-center">
                                    <app-green-or-red-dot [value]="data.active"></app-green-or-red-dot>
                                    <span class="pl-2">{{ data.name }}</span>
                                </div>
                                <app-button
                                    icon="pi-pencil"
                                    [rounded]="true"
                                    [text]="true"
                                    [style]="{ zIndex: 1 }"
                                    (clickEvent)="updateGroup(data)"/>
                            </div>
                        </ng-template>
                    </app-select-input>

                    <app-link-button
                        label="service.nursingDiagnoses.createGroup"
                        [style]="{ padding: 0 }"
                        (clickEvent)="createGroup()"
                    ></app-link-button>
                </div>
            </div>
            <app-text-input class="fr-3" label="service.nursingDiagnoses.fields.description" [form]="form"
                id="description"></app-text-input>

            <p-divider class="fr-6"></p-divider>

            <p-tabs class="fr-4" value="symptoms">
                <p-tablist>
                    <p-tab value="symptoms">{{ 'service.nursingDiagnoses.tabs.symptoms.name' | translate }}</p-tab>
                    <p-tab value="factors">{{ 'service.nursingDiagnoses.tabs.factors.name' | translate }}</p-tab>
                    <p-tab value="riskFactors">{{ 'service.nursingDiagnoses.tabs.riskFactors.name' | translate }}
                    </p-tab>
                    <p-tab value="goals">{{ 'service.nursingDiagnoses.tabs.goals.name' | translate }}</p-tab>
                    <p-tab value="interventions">{{ 'service.nursingDiagnoses.tabs.interventions.name' | translate }}
                    </p-tab>
                </p-tablist>

                <p-tabpanels>
                    <p-tabpanel value="symptoms">
                        <app-nursing-diagnosis-tab
                            [items]="props.symptoms"
                            [title]="'service.nursingDiagnoses.tabs.symptoms.title'"
                            tooltip="service.nursingDiagnoses.tabs.symptoms.addToDiagnosis"
                            (add)="addToDiagnosis('symptoms')"
                            (edit)="editDiagnosisProp('symptoms', $event)"
                            (remove)="removeFromDiagnosis('symptoms', $event)"
                        ></app-nursing-diagnosis-tab>
                    </p-tabpanel>
                    <p-tabpanel value="factors">
                        <app-nursing-diagnosis-tab
                            [items]="props.factors"
                            [title]="'service.nursingDiagnoses.tabs.factors.title'"
                            tooltip="service.nursingDiagnoses.tabs.factors.addToDiagnosis"
                            (add)="addToDiagnosis('factors')"
                            (edit)="editDiagnosisProp('factors', $event)"
                            (remove)="removeFromDiagnosis('factors', $event)"
                        ></app-nursing-diagnosis-tab>
                    </p-tabpanel>
                    <p-tabpanel value="riskFactors">
                        <app-nursing-diagnosis-tab
                            [items]="props.riskFactors"
                            [title]="'service.nursingDiagnoses.tabs.riskFactors.title'"
                            tooltip="service.nursingDiagnoses.tabs.riskFactors.addToDiagnosis"
                            (add)="addToDiagnosis('riskFactors')"
                            (edit)="editDiagnosisProp('riskFactors', $event)"
                            (remove)="removeFromDiagnosis('riskFactors', $event)"
                        ></app-nursing-diagnosis-tab>
                    </p-tabpanel>
                    <p-tabpanel value="goals">
                        <app-nursing-diagnosis-tab
                            [items]="props.goals"
                            [title]="'service.nursingDiagnoses.tabs.goals.title'"
                            tooltip="service.nursingDiagnoses.tabs.goals.addToDiagnosis"
                            (add)="addToDiagnosis('goals')"
                            (edit)="editDiagnosisProp('goals', $event)"
                            (remove)="removeFromDiagnosis('goals', $event)"
                        ></app-nursing-diagnosis-tab>
                    </p-tabpanel>
                    <p-tabpanel value="interventions">
                        <app-nursing-diagnosis-tab
                            [items]="props.interventions"
                            [title]="'service.nursingDiagnoses.tabs.interventions.title'"
                            tooltip="service.nursingDiagnoses.tabs.interventions.addToDiagnosis"
                            (add)="addToDiagnosis('interventions')"
                            (edit)="editDiagnosisProp('interventions', $event)"
                            (remove)="removeFromDiagnosis('interventions', $event)"
                        ></app-nursing-diagnosis-tab>
                    </p-tabpanel>
                </p-tabpanels>
            </p-tabs>
        </div>
    </ng-template>

    <ng-template #footer>
        <app-action-buttons [primaryButtonVisibility]="form.enabled" secondaryButtonType="return"
            (primaryClickEvent)="submit()">
        </app-action-buttons>
    </ng-template>
</app-card>
